module.exports = __webpack_public_path__ + "img/ELLA_MAMA.2429c05f.png";